module.exports = __webpack_public_path__ + "files/0709fd944a6e135d3669631f49dc9511.png";